import { graphql } from "../../graphql"

export const query = graphql(`
  query JourneyNavigationMobile($journeyId: ID!) {
    productCategory(id: $journeyId) {
      id
      title
      backgroundImageUrl
      teaserImageUrl
      isLocked
      progress: journeyProgress {
        certified
      }
    }
    productCategories(isJourney: true, limit: 1, page: 1) {
      pageInfo {
        totalItemCount
      }
    }
  }
`)

export type Journey = {
  id: string
  title: string | null
  backgroundImageUrl: string | null
  teaserImageUrl: string | null
  isLocked: boolean
  progress: {
    certified: boolean
  }
}
